import { useState } from 'react';
import { NewsAndStoriesFilter } from './NewsAndStories.types';

const DEFAULT_FILTER: NewsAndStoriesFilter = {
  searchString: '',
  category: undefined,
  industry: undefined,
  country: undefined,
  year: undefined,
};
export function useNewsAndStoriesPagination<T>() {
  const [page, setPage] = useState(1);

  const onNextPage = () => {
    setPage((prev) => prev + 1);
  };

  const resetPage = () => {
    setPage(1);
  };

  return { page, onNextPage, resetPage };
}

export const useNewsAndStoriesFilter = (defaultFilter: NewsAndStoriesFilter) => {
  const [filter, setFilter] = useState(defaultFilter);
  const [resetCount, setResetCount] = useState(0);

  const setFilterValue = (name: keyof NewsAndStoriesFilter, value: any) => {
    setFilter((prev) => ({ ...prev, [name]: value }));
  };

  const resetFilter = () => {
    setFilter(DEFAULT_FILTER);
    setResetCount((prev) => prev + 1);
  };

  return {
    filter,
    resetCount,
    onResetFilter: resetFilter,
    selectorTitles: {
      type: filter.category?.Name,
      industry: filter.industry?.Name,
      country: filter.country?.Name,
      year: filter.year?.toString(),
    },
    isFilterDirty: JSON.stringify(DEFAULT_FILTER) !== JSON.stringify(filter),
    setFilterValue,
  };
};
